import { useSelector } from 'react-redux';
import { getUserSelector } from '../../security/ducks/principalContextSelectors';
import { PermissionService } from '../../security/service/PermissionService';
import { PermissionType } from '../../security/type/PermissionType';

export const useCanApproveConsents = (): boolean => {
  const user = useSelector(getUserSelector);

  return user
    ? PermissionService.hasOrgBranchPermission(PermissionType.CAN_APPROVE_CONSENTS, user.orgIdsIncludingParents)
    : false;
};
